import React, { useCallback, useRef, useState, useEffect } from 'react'


import { useTranslation } from 'src/utils/i18n'
import Paper from '@mui/material/Paper'
import Image from 'next/image'
import Box from '@mui/material/Box'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

import Modal from '@mui/material/Modal'
import TableContainer from '@mui/material/TableContainer'
import { styled } from '@mui/material/styles'
import { Icon } from '@iconify/react'

import { Pagination, Modal as AntModal } from 'antd'

// request
import { getGcloudAll } from 'src/@api/dashboard'
import dayjs from 'dayjs'

import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import PhotoBox from 'src/@core/components/photos/PhotoBox'
import { motion } from 'framer-motion'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import ContentLoading from 'src/components/ContentLoading'

const BackdropUnstyled = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props

  return <div className={clsx({ 'MuiBackdrop-open': open }, className)} ref={ref} {...other} />
})

BackdropUnstyled.propTypes = {
  className: PropTypes.string.isRequired,
  open: PropTypes.bool
}

const Backdrop = styled(BackdropUnstyled)`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`

const RegisterIllustration = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    height: 500
  }
}))

function formateSeconds(endTime) {
  let secondTime = parseInt(endTime) //将传入的秒的值转化为Number
  let min = 0 // 初始化分
  let h = 0 // 初始化小时
  let result = ''
  if (secondTime > 60) {
    min = parseInt(secondTime / 60)
    secondTime = parseInt(secondTime % 60)
    if (min > 60) {
      h = parseInt(min / 60)
      min = parseInt(min % 60)
    }
  }
  result = `${min.toString().padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`

  return result
}

export default function ModalUnstyledDemo() {
  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false
  const scopeRef = useRef(null)
  const reloadRef = useRef(null)
  const loadNextRef = useRef(null)

  // 文件夹
  const [albumSummary, setAlbumSummary] = useState([])

  const photosPaseUrl = 'https://cos.spyx.com/'

  // 目录层级
  const [level, setLevel] = useState(0)

  // 选中数据
  const [selectedData, setSelectedData] = useState([])

  // 预览图片
  const [photodata, setPhotoData] = useState({})

  // 模态框
  const [open, setOpen] = React.useState(false)

  // 只存储图片数据
  const [useImages, setImages] = useState([])

  // 当前选择页数
  const [total, setTotal] = useState(0)

  // 当前文件夹id
  const [fileRid, setFileRid] = useState('')

  // 滚动dom的ref
  const videoRef = useRef(null)

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  // 当前行参数
  const [row, setRow] = useState(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (videoRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = videoRef.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = videoRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  loadNextRef.current = () => {
    const nowOffset = pagination.nowOffset + pagination.reqNum
    setPagination(page => ({ ...page, nowOffset }))

    if (!pagination.maxNum) handleSelectedPhotos({ row, nowOffset }, scopeRef.current)
  }

  useEffect(() => {
    if (scroll >= 100) loadNextRef.current?.()
  }, [scroll])

  reloadRef.current = scope => {
    // 文件夹
    const setAlbumSummaryData = async () => {
      const { context, signal, isCurrent } = scope
      const response = await getGcloudAll(
        {
          username: context?.username || '',
          params: {
            category: 'ALBUM_SUMMARY',
            ...(context?.physicalDeviceKey ? { deviceUdid: context.physicalDeviceKey } : {})
          }
        },
        { signal }
      )
      if (!isCurrent()) return

      if (response.data.contents != null) {
        response.data.contents = response.data.contents.filter(row => row.name == 'All Videos')

        // let result = response.data.contents.map(item => {
        //   let url = ''
        //   if (item.amount == 0) {
        //     url = '/images/photos/no-photos.png'
        //   } else {
        //     url = item.cover == null ? photosPaseUrl + item.url : photosPaseUrl + item.cover.url
        //   }

        //   return {
        //     ...item,
        //     url: url
        //   }
        // })

        // setLevel(0)
        // setAlbumSummary(result)
        if (response.data.contents.length !== 0) {
          setRow(response.data.contents[0])

          const row = response.data.contents[0]
          await handleSelectedPhotos({ row, nowOffset: 0 }, scope)
        }
      } else {
        setIsLoading(false)
      }
    }
    setAlbumSummaryData().catch(error => {
      if (scope.isCurrent() && error?.code !== 'ERR_CANCELED') {
        console.error(error)
        setIsLoading(false)
      }
    })
  }

  // 设备切换时重置视频列表并重新拉数
  useDeviceScopedInit(
    useCallback((_, scope) => {
      scopeRef.current = scope
      setAlbumSummary([])
      setLevel(0)
      setSelectedData([])
      setPhotoData({})
      setOpen(false)
      setImages([])
      setTotal(0)
      setFileRid('')
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setRow(null)
      setScroll(0)
      setIsLoading(true)
      reloadRef.current?.(scope)
    }, [])
  )

  const handleSelectedPhotos = async ({ row, nowOffset = 0 }, scope = scopeRef.current) => {
    if (!scope || !row) return
    const { context, signal, isCurrent } = scope
    setFileRid(row.id)

    const response = await getGcloudAll(
      {
        username: context?.username || '',
        params: {
          category: 'ALBUM_DETAIL',
          offset: nowOffset,
          limit: pagination.reqNum,
          rid: row.id,
          ...(context?.physicalDeviceKey ? { deviceUdid: context.physicalDeviceKey } : {})
        }
      },
      { signal }
    )
    if (!isCurrent()) return

    setTotal(response.data.totalCount)
    setIsLoading(false)
    if (response.data.contents === null) {
      setLevel(1)
      setSelectedData(old => [...old])
      setPagination(page => ({ ...page, maxNum: true }))

      return
    }

    let result = response.data.contents.map(item => {
      return {
        ...item,
        original_url: item.original.url,
        medium_url: item.medium.url,
        thumb_url: item.thumb.url,
        width: item.thumb.width,
        type:
          item.thumb.type == 'mp4' || item.thumb.type == 'mov' || item.thumb.type == 'video' ? 'mp4' : item.thumb.type,
        cover_url:
          item.thumb.type == 'mp4' || item.thumb.type == 'mov' || item.thumb.type == 'video' ? item.cover.url : '',
        cover_duration:
          item.thumb.type == 'mp4' || item.thumb.type == 'mov' || item.thumb.type == 'video'
            ? formateSeconds(item.cover.duration)
            : ''
      }
    })

    setLevel(1)
    setSelectedData(old => [...old, ...result])

    // 图片独立存储一份

    let images = result.filter(item => {
      return item.type != 'mp4'
    })
    setImages(old => [...old, ...images])
  }

  // 打开模态框
  const handleOpen = () => {
    setOpen(true)
  }

  // 关闭
  const handleClose = () => setOpen(false)

  const openSetPhotoData = result => {
    if (JSON.stringify(result.medium) != '{}') {
      setPhotoData({ id: result.id, ...result.medium })
    } else {
      setPhotoData({ id: result.id, ...result.original })
    }
  }

  // 上一个图片
  const previousPhotos = () => {
    let index = useImages.findIndex(item => {
      return item.id == photodata.id
    })

    let result = useImages[index - 1]

    if (typeof result === 'undefined') return
    if (JSON.stringify(result.medium) != '{}') {
      setPhotoData({ id: result.id, ...result.medium })
    } else {
      setPhotoData({ id: result.id, ...result.original })
    }
  }

  //  下一个图片
  const nextPhotos = () => {
    let index = useImages.findIndex(item => {
      return item.id == photodata.id
    })
    let result = useImages[index + 1]

    if (typeof result === 'undefined') return
    if (JSON.stringify(result.medium) != '{}') {
      setPhotoData({ id: result.id, ...result.medium })
    } else {
      setPhotoData({ id: result.id, ...result.original })
    }
  }

  // 分页
  const onChangePage = async (page, pageSize) => {
    const scope = scopeRef.current
    if (!scope) return
    const { context, signal, isCurrent } = scope
    const response = await getGcloudAll(
      {
        username: context?.username || '',
        params: {
          category: 'ALBUM_DETAIL',
          offset: (page - 1) * pageSize,
          limit: pageSize,
          rid: fileRid,
          ...(context?.physicalDeviceKey ? { deviceUdid: context.physicalDeviceKey } : {})
        }
      },
      { signal }
    )
    if (!isCurrent()) return

    setTotal(response.data.totalCount)

    if (response.data.contents === null) {
      setLevel(1)
      setSelectedData([])

      return
    }

    let result = response.data.contents.map(item => {
      return {
        ...item,
        original_url: item.original.url,
        medium_url: item.medium.url,
        thumb_url: item.thumb.url,
        width: item.thumb.width,
        type:
          item.thumb.type == 'mp4' || item.thumb.type == 'mov' || item.thumb.type == 'video' ? 'mp4' : item.thumb.type,
        cover_url:
          item.thumb.type == 'mp4' || item.thumb.type == 'mov' || item.thumb.type == 'video' ? item.cover.url : '',
        cover_duration:
          item.thumb.type == 'mp4' || item.thumb.type == 'mov' || item.thumb.type == 'video'
            ? formateSeconds(item.cover.duration)
            : '',
        play: false
      }
    })

    setLevel(1)
    setSelectedData(result)

    // 图片独立存储一份

    let images = result.filter(item => {
      return item.type != 'mp4'
    })
    setImages(images)
  }

  // 返回目录
  const goBack = () => {
    setLevel(0)
  }

  const listHeight = useRef()
  const [videoHeight, setVideoHeight] = useState(0)
  const [currentVideo, setCurrentVideo] = useState({})

  // 播放视频模态框
  const [videoModalOpen, setVideoModalOpen] = useState(false)

  // 关闭视频模态框
  const cancelVideoModalOpen = () => {
    setVideoModalOpen(false)
    setCurrentVideo({})
  }

  // 当前视频对象

  const palyVideo = row => {
    setVideoHeight(listHeight.current.clientHeight)

    setVideoModalOpen(true)
    setCurrentVideo(row)
  }
  const { t } = useTranslation('common')

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCurrentTab(t('Video')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      <div
        className={`bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col relative`}
      >
        <div ref={videoRef} className='py-[12px] grid gap-x-[9px] gap-y-[11px] sm:gap-x-1 grid-cols-2 Sixmds:grid-cols-4 Blds:grid-cols-6 overflow-auto'>
          {selectedData.map(item => {
            return (
              <div key={item.id} ref={listHeight}>
                {item.type != 'mp4' && item.type != 'video' ? (
                  <div className='h-full'>
                    <div onClick={handleOpen} className='cursor-pointer'>
                      {/* 图片 */}

                      <PhotoBox
                        src={photosPaseUrl + item.thumb_url}
                        onClick={() => openSetPhotoData(item)}
                        alt={item.filename}
                        width={0}
                        height={0}
                        className='cursor-pointer w-full'
                        bro={
                          <div className='w-full text-[12px] pt-[8px] text-[#000]'>
                            {item.created && dayjs(item.created).format('YYYY/MM/DD HH:mm')}
                            {item.date && dayjs.unix(item.date).format('YYYY/MM/DD HH:mm')}
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    {item.play ? (
                      <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
                        <video
                          controls={true}
                          autoPlay={false}
                          id='video'
                          preload='none'
                          loop={false}
                          muted={false}
                          style={{ width: '100%', height: '100%', maxHeight: videoHeight + 'px' }}
                        >
                          <source src={photosPaseUrl + item.thumb_url} />
                          <source src='movie.ogg' type='video/ogg' />
                        </video>
                      </div>
                    ) : (
                      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <PhotoBox
                          src={photosPaseUrl + item.cover_url}
                          alt={item.filename}
                          width={0}
                          height={0}
                          className='cursor-pointer w-full'
                          onClick={() => palyVideo(item)}
                          bro={
                            <>
                              <div className='w-full text-[12px] pt-[8px] text-[#000]'>
                                {item.created && dayjs(item.created).format('YYYY/MM/DD HH:mm')}
                                {item.date && dayjs.unix(item.date).format('YYYY/MM/DD HH:mm')}
                              </div>
                              <Image
                                src='/images/photos/play.png'
                                width={30}
                                height={30}
                                alt='play'
                                style={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -36px)'
                                }}
                                className='cursor-pointer'
                                onClick={() => palyVideo(item)}
                              />
                              <p
                                style={{
                                  position: 'absolute',
                                  bottom: '0',
                                  right: '4px',
                                  color: '#fff',
                                  fontSize: '14px'
                                }}
                                className='cursor-pointer'
                                onClick={() => palyVideo(item)}
                              >
                                {item.cover_duration}
                              </p>
                            </>
                          }
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            )
          })}

          <Modal
            zIndex={1200}
            aria-labelledby='unstyled-modal-title'
            aria-describedby='unstyled-modal-description'
            open={open}
            onClose={handleClose}
            slots={{ backdrop: Backdrop }}
            className=''
            style={{
              position: 'fixed',
              width: '100%',
              zIndex: '1300',
              right: '0',
              bottom: '0',
              top: '0',
              left: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div className='  rounded-sm   mx-auto'>
              <div className='flex relative w-full  items-center justify-center  shadow-2x'>
                <RegisterIllustration src={'https://cos.spyx.com/' + photodata.url}></RegisterIllustration>
                <div className=' flex w-full  absolute'>
                  <div
                    className='flex items-center justify-star  cursor-pointer  w-1/2 md:h-[400px] sm:h-[260px] md:invisible'
                    onClick={previousPhotos}
                  >
                    <Icon
                      icon='material-symbols:chevron-left-rounded'
                      className='flex items-center ml-6 w-[50px] h-[50px]  text-white'
                    />
                  </div>
                  <div
                    className='flex justify-end items-center cursor-pointer  w-1/2 md:h-[400px] sm:h-[260px] md:invisible'
                    onClick={nextPhotos}
                  >
                    <Icon
                      icon='material-symbols:chevron-right-rounded'
                      className='w-[50px] h-[50px]  text-white  flex mr-6 '
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </Modal>
          {/* <AntModal title={currentVideo.filename} open={videoModalOpen} onCancel={cancelVideoModalOpen} footer={[]}>
            <video
              controls={true}
              autoPlay={true}
              id='video'
              preload='auto'
              loop={false}
              muted={false}
              style={{ width: '100%', height: '100%' }}
              src={photosPaseUrl + currentVideo.original_url}
            ></video>
          </AntModal> */}
        </div>
        {videoModalOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            className='absolute w-full h-full bg-[rgba(0,0,0,0.5)] flex justify-center items-center flex-col'
            onClick={() => {
              cancelVideoModalOpen()
            }}
          >
            <video
              controls={true}
              autoPlay={true}
              id='video'
              preload='auto'
              loop={false}
              muted={false}
              className='max-w-[80%] max-h-[80%]'
              src={photosPaseUrl + currentVideo.original_url}
              onClick={e => e.stopPropagation()}
            ></video>
          </motion.div>
        )}
        {isLoading ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
        {(selectedData.length > 0 || isLoading) ||
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </>
  )
}


